<template>
  <div class="subscribe">
    <van-notice-bar wrapable :scrollable="false" color="#333">
      <p style="font-size:12px;">想要做的职位和雇主上线了，但您却不知道！通过订阅可以实时了解最新的发布信息以及指定的雇主。赶快来设置订阅条件吧！</p>
    </van-notice-bar>
    <div class="sub-head">
      <div class="cur-name van-ellipsis" ref="curName" @click="show = true">
        当前条件：<span>
          {{curItem.showString}}
          <i v-for="(tags, sub) in curItem.positionTagViews" :key="sub" :class="'icon-tag ' + tags.tagStyle">{{tags.tagDisplayName}}</i>
        </span>
      </div>
      <div class="list-select" @click="show = true">
        <van-icon :size="20" name="arrow-down" />
      </div>
    </div>

    <van-list
            v-if="(curItem.id && list && list.length) || loading"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
      <position v-for="(item,index) in list" :key="index" :position="item"></position>
    </van-list>
    <no-data v-else></no-data>

    <van-popup
      v-model="show"
      position="top"
      :style="{ 'max-height': '60%' }"
    >
    <div class="sub-list-area">
      <span v-for="(item , index) in listSub" :key="index" :class="item.id == curItem.id?'cur':''" @click="setCur(item)">
        {{ item.showString }}
        <i v-for="(tags, sub) in item.positionTagViews" :key="sub" :class="'icon-tag ' + tags.tagStyle">{{tags.tagDisplayName}}</i>  
      </span>
    </div>
    </van-popup>

    <div class="btn-add">
      <van-button plain type="primary" @click="goAdd">添加订阅</van-button>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.subscribe {
  background-color: #f5f5f5;
  .btn-add {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 15px;
    background-color: #fafafa;
    z-index: 1000;
    .van-button {
      width:100%;
    }
  }
}
  .subscribe-inner {
    min-height: 300px;
  }
  .sub-head {
    height:50px;
    width:100%;
    border-bottom:0.5px solid #efefef;
    background-color: #fff;
    .cur-name {
      float: left;
      line-height:50px;
      font-size:14px;
      padding:0 15px;
      max-width: 80%;
      i.icon-tag {
          margin-left: 0;
          font-style: normal;
      }
    }
    .list-select {
      float:right;
      width:50px;
      line-height:58px;
      text-align: center;
    }
  }
  .sub-list-area {
    padding:15px;
    padding-top: 10px;
    padding-bottom:15px;
    overflow: hidden;
    span {
      float:left;
      padding:3px;
      font-size:12px;
      background:#f5f5f5;
      border:0.5px solid #f5f5f5;
      margin:0px 2px;
      margin-top:5px;
      border-radius: 4px;
    }
    span.cur {
      color:#00b29c;
      background:#fff;
      border:0.5px solid #00b29c;
    }
    i.icon-tag {
          margin-left: 0;
          font-style: normal;
    }
  }
</style>

<script>
// 本页加载 根据 是否有值 显示添加还是列表

import { subscriptionList , getPositionList} from "@/api/subscribe";
import {getPositionTags, getPositionStatistics} from '@/api/positions'
import Position from "@/components/position/position";
import NoData from "@/components/noData";

export default {
  name: "subscribe-module",
  components: {
    Position, NoData
  },
  data(){
    return {
      show:false,
      listSub:[],
      curItem:{},
      list: [],
      temp: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      curIds: [],
      tagList: [],
      companyList: []
    }
  },
  methods: {
    goAdd(){
      this.$router.push({ path:'/subscribe/add', query:{ hasData:1 } });
    },
    setCur(item){
      this.curItem = item;
      this.show = false;
    },
    onLoad() {
      this.loading = true;
      let params = {pageNo:this.pageNo, pageSize: this.pageSize, conditionIds: this.curItem.id , queryType:1};

      getPositionList(params).then(res=>{
        let curIds = [];
        if(res.data && res.data.positionTags){
          res.data.positionTags.forEach(item=>{
            item.positionTagIdsForSearchUnderRange = item.code;
          })
          this.tagList = res.data.positionTags;
        }

        if(res.data&&res.data.companys&&res.data.companys.values&&res.data.companys.values.length){
          this.companyList = res.data.companys.values;
        }
        
        if(res.data&&res.data.list){
          curIds = res.data.list.map(item=>item.positionId) || [];

          res.data.list.forEach(item=>{
            item.positionTags = [];
            item.statics = {};
          })

          this.list = this.list.concat(res.data.list);

          this.pageNo++;
          if(res.data.list.length < this.pageSize)
            this.finished = true;
        }else{
          this.finished = true;
        }
        
        if(curIds && curIds.length){
          this.positionTags(curIds);
          this.positionStatistics(curIds);
        }
      }).catch(err=>{}).finally(()=>{this.loading = false;});
    },
    positionTags(curIds){
      getPositionTags({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.positionTags = res.data[item.positionId];  
          }
        })
      }).catch(err=>{})
    },
    positionStatistics(curIds){
      getPositionStatistics({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.statics = res.data[item.positionId];  
          }
        })
      }).catch(err=>{})
    }
  },
  watch: {
    curItem(n,o){
      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
    }
  },
  created() {
    
    subscriptionList().then( res => {
      let d = res.data || [];
      if(!d.length){
        this.$router.push({ path:'/subscribe/add' , query:{ hasData:2 }});
        return;
      };

      let ids = [];
      d.forEach(cols => {
        ids.push(cols.id);
      });

      let all = [{
        id:ids.join(','),
        showString:'全部'
      }];

      this.listSub = all.concat(d);
      this.curItem = this.listSub[0];
    }).catch( err => {

    });
  }
};
</script>
